module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p14-fa5c8475369724fe079f7fa33e2653d3.png";